import React, { useMemo } from "react";
import { useRootElement } from "../context";
import * as styles from "./styles";

/**
 * Note: This component is based on this article:
 * https://codeburst.io/how-to-pure-css-pie-charts-w-css-variables-38287aea161e
 *
 * Please read this for a better understanding of how this works.
 */
export const Donut = () => {
  const { data, colors, icon } = useRootElement();

  const total = data.reduce((acc, curr) => acc + curr, 0);

  const segments = useMemo(
    () =>
      data.map((value, index) => {
        const valuePercent = (value / total) * 100;
        const isOver50 = valuePercent > 50;
        const offset = data
          .slice(0, index)
          .reduce((acc, curr) => acc + curr, 0);
        const degrees = (offset / total) * 360;
        const beforeElDegrees = (value / total) * 360;

        const clipPathA = isOver50 ? "-100%" : "0%";
        const clipPathB = isOver50 ? "200%" : "100%";
        const clipPath = `polygon(${clipPathA} ${clipPathA}, ${clipPathB} ${clipPathA}, ${clipPathB} ${clipPathB}, ${clipPathA} ${clipPathB})`;

        return (
          <div
            key={`segment-${index}`}
            className="ll-donut-segment"
            style={
              {
                "--ll-chart-donut-segment-clip-path": clipPath,
                "--ll-chart-donut-segment-bg": colors?.[index] ?? "#000",
                "--ll-chart-donut-segment-degrees": degrees,
                "--ll-chart-donut-segment-before-degrees": beforeElDegrees,
                "--ll-chart-donut-segment-opacity": isOver50 ? 1 : 0,
              } as React.CSSProperties
            }
          ></div>
        );
      }),
    [data, colors],
  );

  return (
    <div className={styles.container}>
      {segments}
      <div className={styles.hole}>
        <div className={styles.iconContainer}>{icon}</div>
      </div>
    </div>
  );
};
